import { render } from "./cp_works_detail.vue?vue&type=template&id=cdfd2ab2"
import script from "./cp_works_detail.vue?vue&type=script&lang=js"
export * from "./cp_works_detail.vue?vue&type=script&lang=js"

import "./cp_works_detail.vue?vue&type=style&index=0&id=cdfd2ab2&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\vue\\portfolio-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__